import React, { useState } from 'react';
import { getBooksLld } from '../../store/booksLld/actions';
import { getLongLocationWaitingUsers } from '../../store/lldWaitingUsers/actions';
import { connect } from 'react-redux';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import BookingsLldTable from './BookingsLldTable';
import LldWaitingUsersTable from './LldWaitingUsersTable';
import ValidationModal from '../Layout/ValidationModal';
import { getDayFirstSecondeDate, getDayLastSecondeDate } from '../../services/DateService';

function a11yProps(index) {
  return {
    id: `lld-rent-${index}`,
    key: `lld-rent-${index}`,
    'aria-controls': `lld-rent-tab-${index}`,
  };
}

const BookingsLldTabs = (props) => {
  const {
    authUser,
    roles,
    selectedSite,
    booksLld,
    getBooksLld,
    lldWaitingUsers,
    getLongLocationWaitingUsers,
  } = props;
  const [tabValue, setTabValue] = useState(0);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalHandleValidate, setModalHandleValidate] = useState(() => {
  });
  const [modalTitle, setModalTitle] = useState('');
  const [modalText, setModalText] = useState('');

  const openDialog = (title, text, action) => {
    setModalTitle(title);
    setModalText(text);
    setModalHandleValidate(action);
    setModalVisible(true);
  };

  const modalHandleClose = () => {
    setModalVisible(false);
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (authUser && roles) {
    if (!booksLld.content && !booksLld.pending && !booksLld.error) {
      getBooksLld(authUser.ma, roles[props.authUser.uid], null, null, selectedSite);
    }
    if (
      !lldWaitingUsers.content
      && !lldWaitingUsers.pending
      && !lldWaitingUsers.error
    ) {
      getLongLocationWaitingUsers(authUser.ma);
    }
  }

  const role = (authUser && roles && roles[authUser.uid]) || ROLE_USER;
  let todayBikesRetreat = [];
  if (booksLld.content) {
    let start = getDayFirstSecondeDate();
    let end = getDayLastSecondeDate();
    todayBikesRetreat = booksLld.content.filter(elem => {
      return elem.date > (start.getTime() / 1000)
        && elem.date < (end.getTime() / 1000);
    });
  }

  const waitingUserList = lldWaitingUsers.content
    ? lldWaitingUsers.content.filter(
      (wu) => {
        return selectedSite === undefined
        || selectedSite === null
        || selectedSite === ''
        || wu.siteId === selectedSite
      }
    )
    : [];

  return (
    <React.Fragment>
      <Tabs value={tabValue} onChange={handleChange}>
        <Tab label="RETRAITS DU JOUR" {...a11yProps(0)} />
        <Tab label="TOUTES LES RESERVATIONS" {...a11yProps(1)} />
        {role === ROLE_ADMIN && <Tab label="LISTE D'ATTENTE" {...a11yProps(2)} />}
      </Tabs>
      <div
        role="tabpanel"
        hidden={tabValue !== 0}
        id={`books-lld-tabpanel-0`}
        aria-labelledby={`books-lld-tab-0`}
      >
        {todayBikesRetreat && <BookingsLldTable
          booksLld={todayBikesRetreat}
          pending={booksLld.pending}
          openDialog={openDialog}
        />}
      </div>
      <div
        role="tabpanel"
        hidden={tabValue !== 1}
        id={`books-lld-tabpanel-1`}
        aria-labelledby={`books-lld-tab-1`}
      >
        {booksLld.content && <BookingsLldTable
          booksLld={booksLld.content}
          pending={booksLld.pending}
          openDialog={openDialog}
        />}
      </div>
      {role === ROLE_ADMIN && <div
        role="tabpanel"
        hidden={tabValue !== 2}
        id={`books-lld-tabpanel-2`}
        aria-labelledby={`books-lld-tab-2`}
      >
        {<LldWaitingUsersTable
          lldWaitingUsers={waitingUserList}
          pending={lldWaitingUsers.pending}
          openDialog={openDialog}
        />}
      </div>}
      <ValidationModal
        visible={modalVisible}
        handleValidate={() => modalHandleValidate()}
        handleClose={modalHandleClose}
        title={modalTitle}
        text={modalText}
        validationText={'Oui, supprimer'}
        closeText={'Non, annuler'}
      />
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  authUser: state.users.authUser,
  roles: state.roles.content,
  selectedSite: state.sitesLld.selected,
  booksLld: state.booksLld,
  lldWaitingUsers: state.lldWaitingUsers,
});

export default connect(mapStateToProps,
  { getBooksLld, getLongLocationWaitingUsers },
)(BookingsLldTabs);



// WEBPACK FOOTER //
// ./src/components/BookingsLld/BookingsLldTabs.jsx